import React, { useEffect, useState } from "react";
import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import { Flex, Select, Spin } from "antd";
import Vector3 from "../assets/myOrders/Vector3.png";
import "../styles/myOrders.css";
import EmptyOrder from "../components/MyOrders/EmptyOrder";
import Orders from "../components/MyOrders/Orders";
import { fetchOrdersByStatus } from "../redux/orderStatusSlice";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";

const MyOrders = () => {

    const { t, i18n } = useTranslation();
    const { language } = i18n;

    const [filter, setFilter] = useState("all");

    const handleChange = (value) => {
        setFilter(value);
    };

    const [hide, setHide] = useState(true);

    const [selectedStatus, setSelectedStatus] = useState("pending");
    const [selectedStatusProg, setSelectedStatusProg] = useState("progress");
    const [selectedStatusFin, setSelectedStatusFin] = useState("finished");

    const [orders, setOrders] = useState([]);
    const [ordersProg, setOrdersProg] = useState([]);
    const [ordersFin, setOrdersFin] = useState([]);

    const [loading, setLoading] = useState(false);
    const dispatch = useDispatch();

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {

                const result = await dispatch(fetchOrdersByStatus(selectedStatus)).unwrap();

                setOrders(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatus, dispatch]);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const result = await dispatch(
                    fetchOrdersByStatus(selectedStatusProg)
                ).unwrap();

                setOrdersProg(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatusProg, dispatch]);

    useEffect(() => {
        const fetchOrders = async () => {
            setLoading(true);
            try {
                const result = await dispatch(
                    fetchOrdersByStatus(selectedStatusFin)
                ).unwrap();

                setOrdersFin(result || []);
            } catch (error) {
                console.error("Error fetching orders:", error);
            } finally {
                setLoading(false);
            }
        };
        fetchOrders();
    }, [selectedStatusFin, dispatch]);


    const dynamicStyle = {
        width: window.innerWidth <= 1024 ? '180' : '220',
    };
    const handleHide = () => {
        if (hide === true) {
            setHide(false);
        } else {
            setHide(true);
        }
    };

    return (
        <div>
            <Navbar />
            <div className="px-20 max-lg:px-5">
                <div className="text-center">
                    <h2 className="text-[#14294F] text-2xl sm:text-3xl md:text-4xl font-extrabold mt-12 max-lg:mt-5 mr-5 leading-relaxed">
                        {t("ALL ORDERS")}
                    </h2>
                    <img
                        src={Vector3}
                        alt="Vector"
                        className="absolute arrow w-[80px] h-[50px] lg:w-[180px] lg:h-[200px] max-lg:hidden mt-7"
                    />
                </div>
                <div className="flex justify-end items-center StoreProducts my-14 max-lg:my-6 mr-8">
                    <p className={`${language == "en" ? "mr-3" : "ml-3"} text-[#283D63] font-semibold`}>{t("Filter")}</p>
                    <Select
                        defaultValue="all"
                        style={dynamicStyle}
                        className="border-2  border-[#4F71A8] w-[180px]"
                        onChange={handleChange}
                        options={[
                            {
                                value: "all",
                                label: t("All"),
                            },
                            {
                                value: "Store_orders",
                                label: t("Store orders"),
                            },
                            {
                                value: "Service_requests",
                                label: t("Service requests"),
                            },
                        ]}
                    />
                </div>
            </div>

            {loading ? (
                <Flex align="center" gap="middle">
                    <Spin size="large" className="mx-auto my-10" style={{ color: '#fe9b71' }} />
                </Flex>
            ) : orders?.data?.length > 0 || ordersProg?.data?.length > 0 || ordersFin?.data?.length > 0 ? (
                <Orders filter={filter}/>
            ) : (
                <EmptyOrder />
            )}

            <Footer />
        </div>
    )
}

export default MyOrders